import Model from "../../../Model.js";

/**
 * TODO: write documentation
 */
export default class AccessRight extends Model {
	isReadOnly() {
		return false;
	}

	isReadWrite() {
		return false;
	}

	allowsRead() {
		return this.isReadOnly() || this.isReadWrite();
	}

	serialize() {
		return this.constructor.getType();
	}
}
